// WETH Address
const BNB_ADDRESS = '0x26841a0A5D958B128209F4ea9a1DD7E61558c330'

export { BNB_ADDRESS }
